import { notification } from 'src/components/Notification';

export const getPdfConvertIcon = () => {
  const icon = document.createElement('span');
  icon.className = 'filepond--download-icon';
  icon.title = 'PDF convert';
  return icon;
};

export const onClick = async (e, item, onClickConvertPdf, removeIcon) => {
  e.stopPropagation();
  notification.success('CONVERTING TO PDF');

  removeIcon();

  await onClickConvertPdf(item.file.name, item.file.attachmentId);
};
export const registerPdfConvertComponent = (item, el, onClickConvertPdf) => {

  if(!item.file.showPdfButton) {
    return;
  }

  const info = el.querySelector('.filepond--file-info-main');
  const PdfConvertIcon = getPdfConvertIcon();

  info.prepend(PdfConvertIcon);
  const removeIcon = () => {
    const iconNode = el.querySelector('.filepond--download-icon');
    iconNode.remove();
  };

  PdfConvertIcon.addEventListener('click', (e) => onClick(e, item, onClickConvertPdf, removeIcon));
};

const plugin = fpAPI => {

  const { addFilter, utils } = fpAPI;
  const { Type, createRoute } = utils;

  addFilter('CREATE_VIEW', viewAPI => {
    const { is, view, query } = viewAPI;

    if (!is('file')) {
      return;
    }

    const didLoadItem = ({ root, props }) => {
      const { id } = props;
      const item = query('GET_ITEM', id);

      if (!item || item.archived) {
        return;
      }

      const onClickConvertPdf = root.query('GET_ON_CLICK_CONVERT_PDF');

      registerPdfConvertComponent(item, root.element, onClickConvertPdf);
    };

    view.registerWriter(
      createRoute({
        DID_LOAD_ITEM: didLoadItem
      }, ({ root }) => {

        // eslint-disable-next-line no-useless-return
        if (root.rect.element.hidden) return;
      })
    );
  });

  return {
    options: {
      onClickConvertPdf: [() => {}, Type.FUNCTION],
    }
  };
};

const isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';
if (isBrowser) {
  document.dispatchEvent(new CustomEvent('FilePond:pluginloaded', { detail: plugin }));
}

export default plugin;
